// extracted by mini-css-extract-plugin
module.exports = {"Contact":"contact-module--Contact--ddcXD chapter-module--Body--1iQV0","h1":"contact-module--h1--3dLEe chapter-module--Title--3-a2u"};